import { render, staticRenderFns, recyclableRender, components } from "./SwipeAction.vue?vue&type=template&id=0988ecd2&scoped=true&"
var renderjs
import script from "./SwipeAction.vue?vue&type=script&lang=js&"
export * from "./SwipeAction.vue?vue&type=script&lang=js&"
import style0 from "./SwipeAction.vue?vue&type=style&index=0&id=0988ecd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988ecd2",
  null,
  false,
  components,
  renderjs
)

export default component.exports